/**
 * Initializes multiple instances of a module based on a selector
 * @param {Object} settings - Configuration object with selector and other settings
 * @param {Class} Module - The module class to instantiate
 * @returns {Array|boolean} Array of module instances or false if initialization fails
 */
const initialiser = (settings, Module) => {
  if (!settings || !settings.selector) return false;

  const elements = document.querySelectorAll(settings.selector);

  if (!elements || !elements.length) return false;

  const instances = [...elements].map((el) => {
    const instance = new Module({ el, settings });
    instance.init();
    return instance;
  });

  return instances;
};

export default initialiser;
